import { post } from 'api/request';
import urls from 'configs/urls';

export const submitRegisterForm = ({ data }) =>
  post(null, false, urls.generalUrls.submitRegisterForm, data);
